export const highlightText = (text = "", query = "") => {
  if (!query || !text) return text;

  const escapedQuery = query.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(`(${escapedQuery})`, "gi");

  const parts = text.split(regex);

  return parts.map((part, i) =>
    i % 2 === 1 ? ( // Нечётные индексы — это совпадения
      <span key={i} style={{ backgroundColor: "yellow" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};
